export default {
	sentryDsn: ``,
	sentryTracingDomains: [],
	openReplayProject: 'jIMYCRNbnVAN2bQFQ3Y1',
	pensionInfoWindowUrl: `https://{namespace}-pension.monthio.dev/api/v1/pensions-info/LoginTicket/{pensionSessionId}`,
}
